export enum ForceSensor {
    Series = 'force_sensor.series',
    Size = 'force_sensor.size',
    NominalForce = 'force_sensor.nominal_force',
    Options = 'force_sensor.options',
}
